import * as jsxRuntime from "C:\\3e\\Projects\\front-components-monorepo\\packages\\menu\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment